import React, { useMemo } from 'react';
import { StandardTooltipProps } from './StandardTooltip.types';
import Styled from './StandardTooltip.styled';

function StandardTooltip({
    children,
    titleColor,
    bgColor,
    colorScheme,
    title,
    showCopyToClipboard,
    clipboardContent,
    dispatchSetClipboardContent,
    placement = 'top',
    defaultOpen,
    hasArrow,
    t,
}: StandardTooltipProps) {
    const isInClipboard = useMemo(
        () => showCopyToClipboard && clipboardContent === title,
        [clipboardContent, title, showCopyToClipboard],
    );

    const finalTitle = showCopyToClipboard
        ? (
            <>
                <Styled.TooltipValue>{title}</Styled.TooltipValue>
                <Styled.TooltipCopy2Clipboard>{t(`${isInClipboard ? 'Copied!' : 'Click to copy to clipboard'}`)}</Styled.TooltipCopy2Clipboard>
            </>
        )
        : (<Styled.TooltipValue>{title}</Styled.TooltipValue>);

    return (
        <Styled.StandardTooltipWithOverriddenStyles
            label={finalTitle}
            placement={placement}
            bg={bgColor || colorScheme}
            color={titleColor}
            defaultIsOpen={defaultOpen}
            hasArrow={hasArrow}
            closeOnClick={!showCopyToClipboard}
            gutter={24}
            closeOnScroll
        >
            {showCopyToClipboard
                ? (
                    <Styled.CopyTransparentOverlay
                        onClick={() => {
                            if (dispatchSetClipboardContent) dispatchSetClipboardContent(title);
                        }}
                    >
                        {children || title}
                    </Styled.CopyTransparentOverlay>
                )
                : <Styled.StandardOverlay>{children || title}</Styled.StandardOverlay>}
        </Styled.StandardTooltipWithOverriddenStyles>
    );
}
export default StandardTooltip;
